import { createApp } from 'vue'

import PermissionForm from '@/src/javascripts/settings/permissions/PermissionForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const permissionForm = document.querySelector('#permission-form')
  if (permissionForm && !permissionForm.__vue_app__) {
    createApp({ components: { PermissionForm, BaseAlert } }).mount(permissionForm)
  }
})
